import _ from 'lodash';
import React, {Component} from "react";
import TableRow from "@material-ui/core/TableRow";

export function sortTable({ rows, order, orderBy, secondaryOrderBy, handleValue }) {
	const sorted = _.sortBy(rows, (row) => {
		let val = row[orderBy];

		if (handleValue) {
			return handleValue(val);
		}

		if (secondaryOrderBy) {
			val += row[secondaryOrderBy];
		}

		if (_.isString(val)) {
			return val.toLowerCase();
		}
		return val;
	});

	if (order === 'asc') {
		return sorted;
	} else if (order === 'desc') {
		return sorted.reverse();
	}
}

export const isFiltered = ({ filter, row, fields }) => {
	if (!filter) { return false; }
	const cleanSearch = filter.replace(/[^a-z0-9]/gi,'');
	const re = new RegExp('\\b' + cleanSearch, 'gi');
	return !_.some(fields, field => {
		return re.test(row[field]);
	});
};

export class PureRecordRow extends Component {
	shouldComponentUpdate(nextProps, nextState, nextContext) {
		return _.get(this, 'state.hovered') !== _.get(nextState, 'hovered')
			|| this.props.selected !== nextProps.selected
			|| this.props.refreshId !== nextProps.refreshId;
	}

	render() {
		//const {...other} = this.props
		const {hover, className, children} = this.props;
		return (
			<TableRow
				hover={hover}
				className={className}
				children={children}
			/>
		);
	}
}
